"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("antd/lib/checkbox/style/index.css");

require("./CheckboxComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CheckboxComponent = function CheckboxComponent(_ref) {
  var defaultChecked = _ref.defaultChecked,
      options = _ref.options,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      children = _ref.children,
      isGroup = _ref.isGroup,
      className = _ref.className,
      checked = _ref.checked,
      name = _ref.name,
      id = _ref.id;

  var checkBoxContent = /*#__PURE__*/_react["default"].createElement(_antd.Checkbox, {
    defaultChecked: defaultChecked || false,
    disabled: disabled || false,
    onChange: onClick,
    className: className || "",
    checked: checked || false,
    name: name,
    id: id
  }, children);

  if (isGroup) {
    checkBoxContent = /*#__PURE__*/_react["default"].createElement(_antd.Checkbox.Group, {
      "data-test": "checkbox-component",
      options: options,
      disabled: disabled,
      onChange: onClick,
      checked: checked || false,
      name: name || "",
      id: id || "",
      className: className
    }, children);
  }

  return checkBoxContent;
};

var _default = CheckboxComponent;
exports["default"] = _default;